const RoomCalendarCard = ({ data }) => {
  console.log(data);
  return (
    <tr className="class-table">
      <td>
        <div className="td-con">
          <div className="table-scroll-text">{data.date}</div>
        </div>
      </td>
      <td>
        <div className="td-con">
          <div
            className="table-scroll-text"
            style={{
              color:
                data.day === "Saturday" || data.day === "Sunday"
                  ? "#b29bff"
                  : "",
            }}
          >
            {data.day}
          </div>
        </div>
      </td>
      {data?.rooms?.map((room) => (
        <td key={room._id} style={{ padding: "0", width: "300px" }}>
          <div
            style={{
              display: "table",
              width: "100%",
              height: "100%",
              tableLayout: "fixed",
            }}
          >
            <div style={{ display: "table-row" }}>
              <div
                style={{
                  display: "table-cell",
                  width: "33.333%",
                  padding: " 12px",
                  textAlign: "center",
                  borderRight: "1px solid #ddd",
                  color: room.hours[0].status === "waiting" ? "#f9710f" : "",
                }}
              >
                {room.hours[0]["10:00"]}
              </div>
              <div
                style={{
                  display: "table-cell",
                  width: "33.333%",
                  padding: " 12px",
                  textAlign: "center",
                  borderRight: "1px solid #ddd",
                  color: room.hours[1].status === "waiting" ? "#f9710f" : "",
                }}
              >
                {room.hours[1]["15:00"]}
              </div>
              <div
                style={{
                  display: "table-cell",
                  width: "33.333%",
                  padding: " 12px",
                  textAlign: "center",
                  borderRight: "1px solid #ddd",
                  color: room.hours[2].status === "waiting" ? "#f9710f" : "",
                }}
              >
                {room.hours[2]["19:00"]}
              </div>
            </div>
          </div>
        </td>
      ))}
      <td></td>
    </tr>
  );
};

export default RoomCalendarCard;
